// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8416) return "static/chunks/8416-d497a61f590bd973.js";
	if (chunkId === 1878) return "static/chunks/1878-032596cb0e6d62e4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1126":"a0a5861285e0976f","8666":"659e6f8c364f82fe","9121":"1db2e890584d66f3"}[chunkId] + ".js";
};